<template>
  <div>

  <v-row>
    <v-col cols="12" sm="6" md="6" offset="1">
        <v-combobox
            v-model="item.state"
            :items="orderstateSelectItems"
            :error-messages="stateErrors"
            :no-data-text="$t('global.no_result')"
            :label="$t('order.state')"
            item-text="name"
            item-value="@id"
        ></v-combobox>
    </v-col>
    </v-row>

    <v-row>
      
      <v-col cols="12" sm ="6" md="4" offset="1">
        <v-textarea
            v-model="item.commentTampon"
            :error-messages="CommentTamponErrors"
            :label="$t('orderaction.content')"
            :placeholder="$t('global.no_select')"
            auto-grow
            rows="1"
            row-height="15"
            clearable
        />
      </v-col>

      <v-col cols="12" sm ="6" md="6">
        <span class="commentTemplate" v-if="commentPlaceholder">
          {{$t('comment.FillComment')}}
          <ul>
            <li v-for="exComment in commentPlaceholder" v-bind:key="exComment">{{ exComment }}</li>
          </ul>
        <br>
        </span>
      </v-col>
      
  </v-row>

  </div>
</template>

<script>
import {mapFields} from "vuex-map-fields";
import {mapActions} from "vuex";
import has from "lodash/has";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";


export default {
  name: 'PopupStateGeneral',
  mixins: [validationMixin],

  props: {
    values: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => {}
    },
    initialValues: {
      type: Object,
      default: () => {}
    },
    commentPlaceholder: {
      type: String,
      default: ''
    },

  },

  mounted() {
    this.orderstateGetSelectItems();
  },

  data() {
    return {
      state: null,
    }
  },

  computed: {
    isLoading() {
      return (
          this.isLoading_state
      );
    },

    ...mapFields('orderstate', {
      orderstateSelectItems: 'selectItems',
      isLoading_state : 'isLoading'
    }),


    item() {
      return this.initialValues || this.values ;
    },
    CommentTamponErrors() {
      const errors = [];

      if (!this.$v.item.commentTampon.$dirty) return errors;

      has(this.violations, 'commentTampon') && errors.push(this.violations.commentTampon);

      return errors;
    },
    stateErrors() {
      const errors = [];
      if (!this.$v.item.state.$dirty) return errors;
      has(this.violations, 'state') && errors.push(this.violations.state);
      !this.$v.item.state.required && errors.push(this.$t('global.field_required'));


      return errors;
    },
    violations() {
      return this.errors || {};
    },
  },

  methods: {
    ...mapActions({
      orderstateGetSelectItems: 'orderstate/fetchSelectItems',
    }),
  },


  validations: {
    item: {
      state: {
        required,
      },
      commentTampon: {
      }
    }
  }
}
</script>
<style>
.commentTemplate{
  color: grey
}
</style>
